var _style, _path, _path2, _g, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BCC0D8;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#E09F0D;}\n\t.st3{fill:#243193;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.8,275.3c-7.9,0-14.4-6.4-14.4-14.4v-67.1c0-53.1,43.2-96.3,96.3-96.3h299.5c7.9,0,14.4,6.4,14.4,14.4 s-6.4,14.4-14.4,14.4H112.7c-37.3,0-67.6,30.3-67.6,67.6V261C45.2,268.8,38.7,275.3,30.8,275.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.7,173.6c26.1-39.9,21.6-94-13.4-129.1C288,4.3,222.8,4.3,182.6,44.5c-35.1,35.1-39.5,89.1-13.4,129.1 H341.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.7,188H169.2c-4.9,0-9.4-2.4-12-6.5c-30.2-46.2-23.8-108,15.3-147.1C194.6,12.2,224.1,0,255.4,0 s60.8,12.2,83,34.4c39.1,39.1,45.5,100.9,15.3,147.1C351,185.5,346.5,188,341.7,188z M177.4,159.2h156.1 c18.2-34,12.2-76.8-15.4-104.5c-16.7-16.7-39-25.9-62.6-25.9s-45.9,9.2-62.6,25.9C165.1,82.4,159.1,125.2,177.4,159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M253.4,160.8c-14.7-0.4-25.7-8.2-25.7-15c0-3.4,3-8.5,6.8-8.5c4.6,0,8.2,7.9,18.9,9.1v-24.1 c-11-4.1-23.5-8.8-23.5-24.4c0-15.4,11.4-22.1,23.5-23.6v-3.4c0-1.6,1.8-3,4.1-3c2.1,0,4.1,1.5,4.1,3v3.2 c7.9,0.2,20.7,2.5,20.7,9.6c0,2.8-1.9,8.4-6.4,8.4c-3.4,0-6.2-3.9-14.3-4.5v21.3c10.8,4,22.9,9.5,22.9,25.9 c0,14.9-9.3,23.5-22.9,25.7v3.8c0,1.6-2.1,3-4.1,3c-2.3,0-4.1-1.5-4.1-3L253.4,160.8L253.4,160.8z M254.4,106.2V87.9 c-6.1,1-9.7,3.9-9.7,8.5C244.7,101.7,248.8,104,254.4,106.2z M260.7,125.2v21.1c5.3-1.1,9.1-4.2,9.1-9.9 C269.8,130.4,265.9,127.5,260.7,125.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M415.5,512H112.7c-53.1,0-96.3-43.2-96.3-96.3V256c0-53.1,43.2-96.3,96.3-96.3h302.8 c27.8,0,50.4,22.6,50.4,50.4v83.6c0,7.9-6.4,14.4-14.4,14.4s-14.4-6.4-14.4-14.4v-83.6c0-11.9-9.7-21.6-21.6-21.6H112.7 c-37.3,0-67.6,30.3-67.6,67.6v159.7c0,37.3,30.3,67.6,67.6,67.6h302.8c11.9,0,21.6-9.7,21.6-21.6V448c0-7.9,6.4-14.4,14.4-14.4 s14.4,6.4,14.4,14.4v13.7C465.9,489.4,443.3,512,415.5,512z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M481.2,387.1H366.7c-30.2,0-54.8-24.5-54.8-54.8l0,0c0-30.2,24.5-54.8,54.8-54.8h114.5V387.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M481.2,401.5H366.7c-38.1,0-69.1-31-69.1-69.1s31-69.1,69.1-69.1h114.5c7.9,0,14.4,6.4,14.4,14.4v109.5 C495.6,395,489.2,401.5,481.2,401.5z M366.7,291.9c-22.3,0-40.4,18.1-40.4,40.4s18.1,40.4,40.4,40.4h100.1v-80.8L366.7,291.9 L366.7,291.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.5cbae7ab5b1e9e26c70eb3c961b48985.svg";
export { ForwardRef as ReactComponent };